document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector(".announcement-bar");

  if (!bar) return;

  const targetTimeString = bar.dataset.endTime || "23:59:59";

  if (targetTimeString.includes(":")) {
    const [targetHours, targetMinutes, targetSeconds] = targetTimeString.split(':').map(Number);

    function getTargetTimeToday() {
      const now = new Date();
      const target = new Date();
      target.setHours(targetHours, targetMinutes, targetSeconds, 0);

      if (target.getTime() < now.getTime()) {
        target.setDate(target.getDate() + 1);
      }

      return target;
    }

    function updateTimer() {
      const now = new Date();
      const target = getTargetTimeToday();
      const distance = target.getTime() - now.getTime();

      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      const hoursEl = document.getElementById("hours");
      const minutesEl = document.getElementById("minutes");
      const secondsEl = document.getElementById("seconds");

      if (hoursEl && minutesEl && secondsEl) {
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }
});
document.addEventListener("DOMContentLoaded", function () {
  function initMobileTestimonials() {
    const slider = $('.lpm_testimonials');
    if (window.innerWidth <= 767 && !slider.hasClass('slick-initialized')) {
      slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false
      });
    }
    if (window.innerWidth > 767 && slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  }
  initMobileTestimonials();
  window.addEventListener('resize', initMobileTestimonials);
});
$(document).ready(function () {
  $('#clickToPro').on('click', function (e) {
    e.preventDefault();
    const target = $('#lp_product');

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 800); // 800ms animation speed
    }
  });
});

$('.product-main-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-thumbnails'
});
$('.product-thumbnails').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.product-main-image',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: true,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: true,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: true,
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: true,
        slidesToShow: 4,
      }
    }
    ]
});

 